"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplatesDialog/RecentlyDeleted.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _templateList = require('shared/services/templateList');
var _time = require('shared/services/time');

var _TemplateEditorModal = require('../TemplateEditorModal');
var _controls = require('./controls');







/* Templates deleted in the last 30 days that I can bring back. */
const RecentlyDeleted = ({ templates, teamNames, onRestore }) => (
  _react2.default.createElement('section', { className: "templates-dialog--deleted", 'aria-labelledby': "templates-dialog-deleted-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
    , _react2.default.createElement('div', { className: "templates-dialog--deleted-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      , _react2.default.createElement('h4', { id: "templates-dialog-deleted-title", className: "templates-dialog--editor-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "Recently deleted" )
      , _react2.default.createElement('p', { className: "tdlg-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, "Deleted templates can be restored for 30 days."       )
    )
    ,  templates.length === 0
      ? _react2.default.createElement('p', { className: "tdlg-meta templates-dialog--deleted-none" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}, "Nothing deleted lately."  )
      : (
        _react2.default.createElement('ul', { className: "templates-dialog--deleted-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
          ,  templates.map(t => (
            _react2.default.createElement('li', { key: t.TemplateKey, className: "tdlg-row templates-dialog--deleted-row" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
              , _react2.default.createElement('div', { className: "tdlg-row--top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
                , _react2.default.createElement('span', { className: "tdlg-row--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}},  t.Name )
                , _react2.default.createElement(_controls.DialogButton, { variant: "out", small: true, className: "templates-dialog--restore", onClick: () => onRestore(t), __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}, "Restore")
              )
              , _react2.default.createElement('div', { className: "tdlg-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
                ,  _templateList.templateScopeLabel.call(void 0, t, teamNames) , " · Deleted by "    , _react2.default.createElement(_TemplateEditorModal.UserName, { userKey: t.UpdatedBy, isAdmin: t.UpdatedByAdmin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} ), " · "  ,  _time.formatLongDisplayDate.call(void 0, t.UpdatedAt) 
              )
            )
          ))
        )
        )
    
  )
)

exports. default = RecentlyDeleted
